const selectors = {
    form: '.js-form:not(.is-initialized)',
    results: '.js-form-results'
}

const classes = {
    loading: 'is-loading',
    loaded: 'is-loaded'
}

let abortController;

const onFormUpdate = (form) => {
    if (!form.checkValidity()) return;

    const resultsContainer = document.querySelector(selectors.results + '#results-' + form.id);
    resultsContainer.classList.add(classes.loading);
    resultsContainer.style.height = resultsContainer.offsetHeight + 'px';

    
    if (abortController) {
        // In case a fetch is already running, abort it.
        abortController.abort();
    }

    loadResults(form);
}

const loadResults = (form) => {
    abortController = new AbortController();
    const { signal } = abortController;

    const data = new FormData(form);
    const action = form.getAttribute('action') || window.location.href;
    const url = `${action}?${new URLSearchParams(data).toString()}`;

    fetch(url, { signal })
        .then(
            response => response.text(),
        )
        .then((res) => {
            window.history.pushState({ path: url }, '', url);

            const parser = new DOMParser();
            const doc = parser.parseFromString(res, 'text/html');
            const results = doc.querySelector(selectors.results  + '#results-' + form.id);
            const resultsContainer = document.querySelector(selectors.results + '#results-' + form.id);

            resultsContainer.classList.add(classes.loaded);

            setTimeout(() => {
                resultsContainer.innerHTML = results.innerHTML;
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => { // Appending takes more than 1 frame on FF
                        document.dispatchEvent(new CustomEvent('domUpdated'));

                        resultsContainer.classList.remove(classes.loading);
                        resultsContainer.classList.remove(classes.loaded);

                        requestAnimationFrame(() => {
                            resultsContainer.style.height = '';
                        });
                    });
                });
            }, 400);
        })
        .catch((err) => {
            if (err.name === 'AbortError') return;
            console.warn(err);
        });
}

const init = () => {
    const forms = document.querySelectorAll(selectors.form);

    forms.forEach(form => {
        form.addEventListener('change', () => {
            onFormUpdate(form);
        });
    });
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;